import { Controller } from '@hotwired/stimulus';

// Turns an in-page jump link (href="#some-id") into a "scroll & reveal" button:
// scrolls its target into view and, when that target is a collapsible card,
// opens its accordion so the content is visible instead of collapsed.
export default class extends Controller {
  open(event) {
    const targetId = (this.element.getAttribute('href') || '').replace(/^#/, '');
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();

    const accordion = this.application.getControllerForElementAndIdentifier(target, 'accordion');
    if (accordion) accordion.open();

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
